import { Tooltip } from "@mui/material";
import _ from "lodash";
import { memo, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { Controller, useFormContext } from "react-hook-form";
import HTMLInput from "../../_Components/HTMLInput";
import SelectComponent from "../../_Components/ReactSelectComponent";
import SplitNumber from "../../_Components/SplitNumber";
import AddCircleRounded from "@mui/icons-material/AddCircleOutlineRounded";


const ReserveItemGroup = ({
  nameDate,
  group,
  reserveDescriptions,
  reserveDetailGroup,
  reserveDetail,
  openModalAddDescription,
  reserveItems,
  reserveDetailDate,
  formatTime
}) => {
  const { setValue, register, watch, control } = useFormContext()

  useEffect(() => {
    setValue(`${nameDate}-${group.id}-Des`, _.find(reserveDescriptions, function (obj) {
      return _.toString(obj.value) === reserveDetailGroup?.gDesId;
    }))
    setValue(`${nameDate}-Des`, _.find(reserveDescriptions, function (obj) {
      return _.toString(obj.value) === reserveDetailDate?.dDesId;
    }))
  }, [])
  return (
    <div className="bg-white rounded-3 p-2 my-3" style={{ border: "1px solid #ddd " }}>
      <div className=" pb-2" style={{ borderBottom: "1px solid #ddd " }}>
        <Row className="justify-content-md-right position-relative">
          <Col sx="12" sm="7" className="my-auto">
            <input
              key={reserveDetail.service.toString() + `${nameDate}-${group.id}-ID`}
              name={`${nameDate}-${group.id}-ID`}
              {...register(`${nameDate}-${group.id}-ID`)}
              defaultChecked={reserveDetailGroup?.gID != null ? reserveDetailGroup.gID : false}
              type="checkbox"
              title="نمایش/عدم نمایش"
              style={{ margin: "0 5px" }}
            />

            <input
              key={reserveDetail.service.toString() + `${nameDate}-${group.id}-IA`}
              name={`${nameDate}-${group.id}-IA`}
              {...register(`${nameDate}-${group.id}-IA`)}
              defaultChecked={reserveDetailGroup?.gIA != null ? reserveDetailGroup.gIA : false}
              type="checkbox"
              title="فعال/غیرفعال"
              style={{ margin: "0 5px" }}
            />
            <span className="fw-bold"> {group.title}</span>
          </Col>
          <Col xs="10" sm="5" className="mt-2 mt-md-0 pr-2 d-flex align-items-center">
            <Controller
              name={`${nameDate}-${group.id}-Des`}
              control={control}
              render={(field) => (
                <SelectComponent
                  className="w-100"
                  variant="outlined"
                  size="small"
                  noLabel
                  placeholder="توضیحات گروه"
                  {...field}
                  options={reserveDescriptions.map(item => ({ ...item, label: item.label.length > 40 ? item.label.slice(0, 40) + "…" : item.label }))}
                />
              )}
            />
            <Button
              onClick={() => openModalAddDescription(nameDate, group.id)}
              variant="light h-100 mx-1"
            >
              <AddCircleRounded
                fontSize="large"
                className="big-icon"
              />
            </Button>

          </Col>
          {/* <Col xs="2" sm="auto" className="my-auto px-0"></Col> */}
        </Row>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {reserveItems.map(function (item, index) {
          let reserveDetailItem =
            !_.isNil(reserveDetailGroup) && _.isArray(reserveDetailGroup.i)
              ? _.find(reserveDetailGroup.i, { iId: item.id })
              : "";
          const dayCapacity = watch(
            `${nameDate}-${group.id}-${item.id}-C`,
            reserveDetailItem?.iC ? reserveDetailItem.iC : item.defaultReserveCountPerDay,
          ); //بررسی لحظه ای ظرفیت روزانه
          const fullCapacity = watch(
            `${nameDate}-${group.id}-${item.id}-IFC`,
            reserveDetailItem?.iIFC != null ? reserveDetailItem.iIFC : item.isFullCapacity,
          ); //بررسی لحظه ای ظرفیت تکمیل

          if (!_.isUndefined(item) && !_.isEmpty(item))
            return (
              <Row
                key={index}
                className="align-items-center position-relative"
                style={{ margin: "10px 0 15px 0" }}
              >
                <Col xs="12" sm className="px-0 d-flex align-items-center mb-3 mb-sm-0">
                  <input
                    name={`${nameDate}-${group.id}-${item.id}-ID`}
                    {...register(`${nameDate}-${group.id}-${item.id}-ID`)}
                    defaultChecked={reserveDetailItem?.iID != null ? reserveDetailItem.iID : false}
                    type="checkbox"
                    // checked={value || item.iID}
                    title="نمایش/عدم نمایش"
                    style={{ margin: "0 5px" }}
                  />{" "}
                  <input
                    name={`${nameDate}-${group.id}-${item.id}-IA`}
                    {...register(`${nameDate}-${group.id}-${item.id}-IA`)}
                    defaultChecked={reserveDetailItem?.iIA != null ? reserveDetailItem.iIA : false}
                    type="checkbox"
                    title="فعال/غیرفعال"
                    style={{ margin: "0 5px" }}
                  />
                  <span>{item.title}</span>
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  <HTMLInput
                    hiddenClear={true}
                    registeredParams={{ ...register(`${nameDate}-${group.id}-${item.id}-MinC`) }}
                    onInput={(e) => {
                      // فقط اعداد مثبت و صفر مجاز باشه
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    defaultValue={
                      reserveDetailItem?.iMinC
                        ? reserveDetailItem.iMinC
                        : item.minimumReserveCountPerDay
                    }
                    margin="normal"
                    variant="outlined"
                    size="small"
                    className="form-control text-center englishInput"
                    title="حداقل تعداد"
                    style={{
                      margin: "0 auto",
                      width: "60px",
                      height: "2.8rem",
                      padding: "0",
                    }}
                    type="number"
                    inputMode="numeric"
                  />

                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 mx-3 position-relative">
                  <HTMLInput
                    hiddenClear={true}
                    registeredParams={{ ...register(`${nameDate}-${group.id}-${item.id}-C`) }}
                    onInput={(e) => {
                      // فقط اعداد مثبت و صفر مجاز باشه
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    defaultValue={
                      reserveDetailItem?.iC ? reserveDetailItem.iC : item.defaultReserveCountPerDay
                    }
                    margin="normal"
                    variant="outlined"
                    size="small"
                    className="form-control text-center englishInput"
                    title="ظرفیت روزانه"
                    style={{
                      margin: "0 auto",
                      width: "60px",
                      height: "2.8rem",
                      padding: "0",
                    }}
                    type="number"
                    inputMode="numeric"
                  />
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  <input
                    name={`${nameDate}-${group.id}-${item.id}-IDL`}
                    {...register(`${nameDate}-${group.id}-${item.id}-IDL`)}
                    type="checkbox"
                    title="محدودیت روزانه اعمال شود؟"
                    style={{ margin: "0 5px" }}
                    defaultChecked={
                      reserveDetailItem && reserveDetailItem.iIDL != null
                        ? reserveDetailItem.iIDL
                        : false
                    }
                  />
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  <input
                    name={`${nameDate}-${group.id}-${item.id}-IFC`}
                    {...register(`${nameDate}-${group.id}-${item.id}-IFC`)}
                    defaultChecked={
                      reserveDetailItem?.iIFC != null ? reserveDetailItem.iIFC : item.isFullCapacity
                    }
                    type="checkbox"
                    title="ظرفیت تکمیل"
                    style={{ margin: "0 5px" }}
                  />
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 min-width-price">
                  <label style={{ margin: "0 5px" }} className="text-decoration-line-through ">
                    <SplitNumber number={item.originalPrice} />
                  </label>
                  <label style={{ margin: "0 5px" }} className="">
                    <SplitNumber number={item.price} />
                  </label>
                </Col>
                <Col xs="auto" sm="auto" className="px-0 mb-2 mb-sm-0">
                  <label style={{ margin: "0 5px" }} className="text-primary">
                    {formatTime(item.reservationExpirationTime)}
                  </label>
                </Col>
                <Col xs="auto" sm="auto" className="px-0 text-center mb-2 mb-sm-0">
                  <span style={{ width: "32px", display: "inline-block" }}>
                    {!_.isEmpty(item.reservationByPhone) && (
                      <Tooltip title={item.reservationByPhone} arrow placement="top">
                        <i className="fa fa-phone text-primary"></i>
                      </Tooltip>
                    )}

                    {((_.isEmpty(item.reservationByPhone) &&
                      (_.isEmpty(_.trim(dayCapacity)) || _.parseInt(dayCapacity) == 0) &&
                      dayCapacity !== undefined) ||
                      fullCapacity) && (
                        <Tooltip title="آیتم قابل رزرو نمی باشد" arrow placement="top">
                          <i className="fa fa-eye-slash text-danger fs-normal flipX"></i>
                        </Tooltip>
                      )}
                  </span>
                </Col>
              </Row>
            );
        })}
      </div>
    </div>
  )
}

export default memo(ReserveItemGroup)